import { render, staticRenderFns } from "./charcolor.vue?vue&type=template&id=6f5e0bc7&scoped=true"
import script from "./charcolor.vue?vue&type=script&lang=js"
export * from "./charcolor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e0bc7",
  null
  
)

export default component.exports